module.exports = __webpack_public_path__ + "static/media/n3.9c62e37b.jpg";